<template>
    <div class="qr-code-item text-center">
        <img :src="src" :alt="label" class="qr-img" :width="width" :height="height" loading="lazy" />
        <p class="qr-label">{{ label }}</p>
    </div>
</template>

<script setup lang="ts">
interface Props {
    label: string
    src: string
    width?: string | number
    height?: string | number
}

const props = withDefaults(defineProps<Props>(), {
    width: '75px',
    height: '75px'
})
</script>

<style scoped lang="scss">
.qr-code-item {
    .qr-img {
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        transition: transform 0.3s ease;
        margin-bottom: 0.25rem;

        &:hover {
            transform: scale(1.05);
        }
    }

    .qr-label {
        font-size: 0.75rem;
        color: #d1d5db;
    }
}
</style>
